export const languages = [
  { label: '英语', value: 'English' },
  { label: '英语（美国）', value: 'English (United States)' },
  { label: '英语（英国）', value: 'English (UK)' },
  { label: '英语（澳大利亚）', value: 'English (Australia)' },
  { label: '英语（加拿大）', value: 'English (Canada)' },
  { label: '英语（印度）', value: 'English (India)' },
  { label: '英语（新加坡）', value: 'English (Singapore)' },
  { label: '英语（爱尔兰）', value: 'English (Ireland)' },
  { label: '英语（新西兰）', value: 'English (New Zealand)' },
  { label: '英语（南非）', value: 'English (South Africa)' },
  { label: '英语（菲律宾）', value: 'English (Philippines)' },
  { label: '英语（中国香港特别行政区）', value: 'English (Hong Kong SAR)' },
  { label: '英语（尼日利亚）', value: 'English (Nigeria)' },
  { label: '英语（肯尼亚）', value: 'English (Kenya)' },
  { label: '英语（坦桑尼亚）', value: 'English (Tanzania)' },
  { label: '中文（普通话，简体）', value: 'Chinese (Mandarin, Simplified)' },
  { label: '普通话', value: 'Mandarin' },
  {
    label: '中文（台湾普通话，繁体）',
    value: 'Chinese (Taiwanese Mandarin, Traditional)',
  },
  { label: '中文（粤语，繁体）', value: 'Chinese (Cantonese, Traditional)' },
  {
    label: '中文（西南官话，简体）',
    value: 'Chinese (Southwestern Mandarin, Simplified)',
  },
  {
    label: '中文（东北官话，简体）',
    value: 'Chinese (Northeastern Mandarin, Simplified)',
  },
  { label: '中文（吴语，简体）', value: 'Chinese (Wu, Simplified)' },
  {
    label: '中文（冀鲁官话，简体）',
    value: 'Chinese (Jilu Mandarin, Simplified)',
  },
  {
    label: '中文（中原官话河南，简体）',
    value: 'Chinese (Zhongyuan Mandarin Henan, Simplified)',
  },
  {
    label: '中文（中原官话陕西，简体）',
    value: 'Chinese (Zhongyuan Mandarin Shaanxi, Simplified)',
  },
  { label: '西班牙语', value: 'Spanish' },
  { label: '西班牙语（西班牙）', value: 'Spanish (Spain)' },
  { label: '西班牙语（墨西哥）', value: 'Spanish (Mexico)' },
  { label: '西班牙语（美国）', value: 'Spanish (United States)' },
  { label: '西班牙语（拉丁美洲）', value: 'Spanish (Latin America)' },
  { label: '西班牙语（阿根廷）', value: 'Spanish (Argentina)' },
  { label: '西班牙语（哥伦比亚）', value: 'Spanish (Colombia)' },
  { label: '西班牙语（智利）', value: 'Spanish (Chile)' },
  { label: '西班牙语（秘鲁）', value: 'Spanish (Peru)' },
  { label: '西班牙语（委内瑞拉）', value: 'Spanish (Venezuela)' },
  { label: '西班牙语（厄瓜多尔）', value: 'Spanish (Ecuador)' },
  { label: '西班牙语（玻利维亚）', value: 'Spanish (Bolivia)' },
  { label: '西班牙语（巴拉圭）', value: 'Spanish (Paraguay)' },
  { label: '西班牙语（乌拉圭）', value: 'Spanish (Uruguay)' },
  { label: '西班牙语（哥斯达黎加）', value: 'Spanish (Costa Rica)' },
  { label: '西班牙语（巴拿马）', value: 'Spanish (Panama)' },
  { label: '西班牙语（危地马拉）', value: 'Spanish (Guatemala)' },
  { label: '西班牙语（洪都拉斯）', value: 'Spanish (Honduras)' },
  { label: '西班牙语（萨尔瓦多）', value: 'Spanish (El Salvador)' },
  { label: '西班牙语（尼加拉瓜）', value: 'Spanish (Nicaragua)' },
  { label: '西班牙语（古巴）', value: 'Spanish (Cuba)' },
  {
    label: '西班牙语（多米尼加共和国）',
    value: 'Spanish (Dominican Republic)',
  },
  { label: '西班牙语（波多黎各）', value: 'Spanish (Puerto Rico)' },
  { label: '西班牙语（赤道几内亚）', value: 'Spanish (Equatorial Guinea)' },
  { label: '阿拉伯语', value: 'Arabic' },
  { label: '阿拉伯语（沙特阿拉伯）', value: 'Arabic (Saudi Arabia)' },
  { label: '阿拉伯语（埃及）', value: 'Arabic (Egypt)' },
  {
    label: '阿拉伯语（阿拉伯联合酋长国）',
    value: 'Arabic (United Arab Emirates)',
  },
  { label: '阿拉伯语（摩洛哥）', value: 'Arabic (Morocco)' },
  { label: '阿拉伯语（阿尔及利亚）', value: 'Arabic (Algeria)' },
  { label: '阿拉伯语（伊拉克）', value: 'Arabic (Iraq)' },
  { label: '阿拉伯语（约旦）', value: 'Arabic (Jordan)' },
  { label: '阿拉伯语（科威特）', value: 'Arabic (Kuwait)' },
  { label: '阿拉伯语（黎巴嫩）', value: 'Arabic (Lebanon)' },
  { label: '阿拉伯语（卡塔尔）', value: 'Arabic (Qatar)' },
  { label: '阿拉伯语（阿曼）', value: 'Arabic (Oman)' },
  { label: '阿拉伯语（巴林）', value: 'Arabic (Bahrain)' },
  { label: '阿拉伯语（利比亚）', value: 'Arabic (Libya)' },
  { label: '阿拉伯语（突尼斯）', value: 'Arabic (Tunisia)' },
  { label: '阿拉伯语（叙利亚）', value: 'Arabic (Syria)' },
  { label: '阿拉伯语（也门）', value: 'Arabic (Yemen)' },
  { label: '阿拉伯语（世界）', value: 'Arabic (World)' },
  { label: '法语', value: 'French' },
  { label: '法语（法国）', value: 'French (France)' },
  { label: '法语（加拿大）', value: 'French (Canada)' },
  { label: '法语（比利时）', value: 'French (Belgium)' },
  { label: '法语（瑞士）', value: 'French (Switzerland)' },
  { label: '葡萄牙语', value: 'Portuguese' },
  { label: '葡萄牙语（巴西）', value: 'Portuguese (Brazil)' },
  { label: '葡萄牙语（葡萄牙）', value: 'Portuguese (Portugal)' },
  { label: '德语', value: 'German' },
  { label: '德语（德国）', value: 'German (Germany)' },
  { label: '德语（奥地利）', value: 'German (Austria)' },
  { label: '德语（瑞士）', value: 'German (Switzerland)' },
  { label: '日语', value: 'Japanese' },
  { label: '日语（日本）', value: 'Japanese (Japan)' },
  { label: '韩语', value: 'Korean' },
  { label: '韩语（韩国）', value: 'Korean (Korea)' },
  { label: '俄语', value: 'Russian' },
  { label: '俄语（俄罗斯）', value: 'Russian (Russia)' },
  { label: '印地语', value: 'Hindi' },
  { label: '印地语（印度）', value: 'Hindi (India)' },
  { label: '孟加拉语（孟加拉国）', value: 'Bangla (Bangladesh)' },
  { label: '孟加拉语（印度）', value: 'Bengali (India)' },
  { label: '乌尔都语（巴基斯坦）', value: 'Urdu (Pakistan)' },
  { label: '乌尔都语（印度）', value: 'Urdu (India)' },
  { label: '泰米尔语', value: 'Tamil' },
  { label: '泰米尔语（印度）', value: 'Tamil (India)' },
  { label: '泰米尔语（斯里兰卡）', value: 'Tamil (Sri Lanka)' },
  { label: '泰米尔语（马来西亚）', value: 'Tamil (Malaysia)' },
  { label: '泰米尔语（新加坡）', value: 'Tamil (Singapore)' },
  { label: '泰卢固语（印度）', value: 'Telugu (India)' },
  { label: '马拉地语（印度）', value: 'Marathi (India)' },
  { label: '古吉拉特语（印度）', value: 'Gujarati (India)' },
  { label: '旁遮普语（印度）', value: 'Punjabi (India)' },
  { label: '卡纳达语（印度）', value: 'Kannada (India)' },
  { label: '马拉雅拉姆语（印度）', value: 'Malayalam (India)' },
  { label: '奥里亚语（印度）', value: 'Odia (India)' },
  { label: '孔卡尼语（印度）', value: 'Konkani (India)' },
  { label: '迈蒂利语（印度）', value: 'Maithili (India)' },
  { label: '信德语（印度）', value: 'Sindhi (India)' },
  { label: '印度尼西亚语', value: 'Indonesian' },
  { label: '印度尼西亚语（印度尼西亚）', value: 'Indonesian (Indonesia)' },
  { label: '马来语', value: 'Malay' },
  { label: '马来语（马来西亚）', value: 'Malay (Malaysia)' },
  { label: '菲律宾语', value: 'Filipino' },
  { label: '菲律宾语（菲律宾）', value: 'Filipino (Philippines)' },
  { label: '菲律宾语（宿务语）', value: 'Filipino (Cebuano)' },
  { label: '越南语', value: 'Vietnamese' },
  { label: '越南语（越南）', value: 'Vietnamese (Vietnam)' },
  { label: '泰语（泰国）', value: 'Thai (Thailand)' },
  { label: '土耳其语', value: 'Turkish' },
  { label: '土耳其语（土耳其）', value: 'Turkish (Türkiye)' },
  { label: '波斯语（伊朗）', value: 'Persian (Iran)' },
  { label: '意大利语', value: 'Italian' },
  { label: '意大利语（意大利）', value: 'Italian (Italy)' },
  { label: '荷兰语', value: 'Dutch' },
  { label: '荷兰语（荷兰）', value: 'Dutch (Netherlands)' },
  { label: '荷兰语（比利时）', value: 'Dutch (Belgium)' },
  { label: '波兰语', value: 'Polish' },
  { label: '波兰语（波兰）', value: 'Polish (Poland)' },
  { label: '乌克兰语', value: 'Ukrainian' },
  { label: '乌克兰语（乌克兰）', value: 'Ukrainian (Ukraine)' },
  { label: '瑞典语', value: 'Swedish' },
  { label: '瑞典语（瑞典）', value: 'Swedish (Sweden)' },
  { label: '挪威博克马尔语（挪威）', value: 'Norwegian Bokmål (Norway)' },
  { label: '挪威尼诺斯克语（挪威）', value: 'Norwegian Nynorsk (Norway)' },
  { label: '丹麦语', value: 'Danish' },
  { label: '丹麦语（丹麦）', value: 'Danish (Denmark)' },
  { label: '芬兰语', value: 'Finnish' },
  { label: '芬兰语（芬兰）', value: 'Finnish (Finland)' },
  { label: '捷克语', value: 'Czech' },
  { label: '捷克语（捷克）', value: 'Czech (Czechia)' },
  { label: '希腊语', value: 'Greek' },
  { label: '希腊语（希腊）', value: 'Greek (Greece)' },
  { label: '罗马尼亚语', value: 'Romanian' },
  { label: '罗马尼亚语（罗马尼亚）', value: 'Romanian (Romania)' },
  { label: '匈牙利语（匈牙利）', value: 'Hungarian (Hungary)' },
  { label: '斯洛伐克语', value: 'Slovak' },
  { label: '斯洛伐克语（斯洛伐克）', value: 'Slovak (Slovakia)' },
  { label: '保加利亚语', value: 'Bulgarian' },
  { label: '保加利亚语（保加利亚）', value: 'Bulgarian (Bulgaria)' },
  { label: '克罗地亚语', value: 'Croatian' },
  { label: '克罗地亚语（克罗地亚）', value: 'Croatian (Croatia)' },
  { label: '塞尔维亚语（拉丁文，塞尔维亚）', value: 'Serbian (Latin, Serbia)' },
  { label: '斯洛文尼亚语（斯洛文尼亚）', value: 'Slovenian (Slovenia)' },
  {
    label: '波斯尼亚语（波斯尼亚和黑塞哥维那）',
    value: 'Bosnian (Bosnia and Herzegovina)',
  },
  { label: '马其顿语（北马其顿）', value: 'Macedonian (North Macedonia)' },
  { label: '阿尔巴尼亚语（阿尔巴尼亚）', value: 'Albanian (Albania)' },
  { label: '爱沙尼亚语（爱沙尼亚）', value: 'Estonian (Estonia)' },
  { label: '拉脱维亚语（拉脱维亚）', value: 'Latvian (Latvia)' },
  { label: '立陶宛语（立陶宛）', value: 'Lithuanian (Lithuania)' },
  { label: '白俄罗斯语（白俄罗斯）', value: 'Belarusian (Belarus)' },
  { label: '希伯来语（以色列）', value: 'Hebrew (Israel)' },
  { label: '斯瓦希里语（肯尼亚）', value: 'Swahili (Kenya)' },
  { label: '斯瓦希里语（坦桑尼亚）', value: 'Swahili (Tanzania)' },
  { label: '南非荷兰语（南非）', value: 'Afrikaans (South Africa)' },
  { label: '祖鲁语（南非）', value: 'Zulu (South Africa)' },
  { label: '索马里语（索马里）', value: 'Somali (Somalia)' },
  { label: '阿姆哈拉语（埃塞俄比亚）', value: 'Amharic (Ethiopia)' },
  { label: '普什图语（阿富汗）', value: 'Pashto (Afghanistan)' },
  { label: '哈萨克语（哈萨克斯坦）', value: 'Kazakh (Kazakhstan)' },
  {
    label: '乌兹别克语（拉丁文，乌兹别克斯坦）',
    value: 'Uzbek (Latin, Uzbekistan)',
  },
  { label: '蒙古语（蒙古）', value: 'Mongolian (Mongolia)' },
  { label: '尼泊尔语（尼泊尔）', value: 'Nepali (Nepal)' },
  { label: '僧伽罗语（斯里兰卡）', value: 'Sinhala (Sri Lanka)' },
  { label: '高棉语（柬埔寨）', value: 'Khmer (Cambodia)' },
  { label: '老挝语（老挝）', value: 'Lao (Laos)' },
  { label: '缅甸语（缅甸）', value: 'Burmese (Myanmar)' },
  { label: '爪哇语（爪哇）', value: 'Javanese (Java)' },
  {
    label: '爪哇语（拉丁文，印度尼西亚）',
    value: 'Javanese (Latin, Indonesia)',
  },
  { label: '巽他语（印度尼西亚）', value: 'Sundanese (Indonesia)' },
  { label: '爱尔兰语（爱尔兰）', value: 'Irish (Ireland)' },
  { label: '威尔士语（英国）', value: 'Welsh (United Kingdom)' },
  { label: '冰岛语（冰岛）', value: 'Icelandic (Iceland)' },
  { label: '卢森堡语（卢森堡）', value: 'Luxembourgish (Luxembourg)' },
  { label: '马耳他语（马耳他）', value: 'Maltese (Malta)' },
  { label: '海地克里奥尔语（海地）', value: 'Haitian Creole (Haiti)' },
  { label: '亚美尼亚语（亚美尼亚）', value: 'Armenian (Armenia)' },
  { label: '格鲁吉亚语（格鲁吉亚）', value: 'Georgian (Georgia)' },
  {
    label: '阿塞拜疆语（拉丁文，阿塞拜疆）',
    value: 'Azerbaijani (Latin, Azerbaijan)',
  },
  { label: '巴斯克语', value: 'Basque' },
  { label: '加泰罗尼亚语', value: 'Catalan' },
  { label: '加利西亚语', value: 'Galician' },
  { label: '马达加斯加语（马达加斯加）', value: 'Malagasy (Madagascar)' },
  { label: '拉丁语（梵蒂冈城）', value: 'Latin (Vatican City)' },
];
